// extracted by mini-css-extract-plugin
module.exports = {"container":"QuillEditor_container__3iODS","counter":"QuillEditor_counter__1x1oK"};